import { getItem } from '../lang';
/**
 * 中文映射表
 */

export const tScope = (value) => {
  const { tScope: scopeTypes } = getItem('dync');
  return scopeTypes[value] || value;
};

export const tAction = (value) => {
  const { tAction: actionType } = getItem('dync');
  return actionType[value] || value;
};

export const tMAttr = (value) => {
  const { measuringType } = getItem('dync');
  return measuringType[value] || value;
};

export const tDevType = (value) => {
  const { tDevType: types } = getItem('dync');
  return types[value] || value;
};

// 设备类别
export const tDevCategory = (value) => {
  const { deviceCategory } = getItem('dync');
  return deviceCategory[value] || value;
};

export const tStructureType = (value) => {
  const { structureType } = getItem('dync');
  return structureType[value] || value;
};

export const tField = (value, pointNameMapper = {}) => {
  const fields = getItem('fields');
  if (value.startsWith('POINT')) {
    const [point, f] = value.split('_');
    const pointName = pointNameMapper[point] || point.slice(5);
    return `${pointName} ${fields[f]}`;
  }
  return fields[value] || value;
};
